/**
 * Returns the offset in minutes from UTC. Bear in mind that getTimezoneOffset returns a negative value
 * for times ahead of UTC and positive values to those behind. For this, we return the reverse
 */
export function getUTCOffset(): number {
  return -new Date().getTimezoneOffset();
}
